import { Divider, Stack, Typography } from '@mui/material';
import { dotDateFormatMM } from 'Config';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { replaceZerosWithHyphen } from 'Utils/replaceZerosWithHyphen';
import { format } from 'date-fns';
import { AppliesNumbers } from './AppliesNumbers';

interface IReferralDetails {
  statusDate: Date | null;
  supplierName?: string;
  requestNumber: number;
  isActive: boolean;
  invalidationDate?: Date;
  linkedApplyNumbers: string[];
}

export const ReferralDetails = ({
  statusDate,
  supplierName,
  requestNumber,
  isActive,
  invalidationDate,
  linkedApplyNumbers,
}: IReferralDetails) => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.MedicalReferrals
  ).referral;
  const isDesktop = useIsDesktop();

  const getStatusDate = () => {
    if (!isActive && invalidationDate)
      return format(new Date(invalidationDate), dotDateFormatMM);

    if (statusDate) return format(new Date(statusDate), dotDateFormatMM);

    return '';
  };

  const formattedRequestNumber = replaceZerosWithHyphen(requestNumber);

  return (
    <Stack padding={isDesktop ? '0' : '20px 16px 0px 16px'}>
      {isDesktop && (
        <Divider
          orientation={'horizontal'}
          aria-hidden={'true'}
          sx={{
            position: 'absolute',
            width: '100%',
            top: '5px',
            left: '0',
            borderColor: 'primary.shade_100',
          }}
        />
      )}
      <Stack
        gap={isDesktop ? '32px' : '20px'}
        maxWidth={isDesktop ? '780px' : 'initial'}
      >
        <Stack
          direction={'row'}
          flexWrap={'wrap'}
          gap={isDesktop ? '40px' : '20px'}
        >
          <Stack
            gap={isDesktop ? '8px' : '4px'}
            width={isDesktop ? '275px' : '135px'}
            flexShrink={0}
          >
            <Typography variant={'body6'}>
              {dictionary.requestNumber}
            </Typography>
            <Typography variant={'body2'}>{formattedRequestNumber}</Typography>
          </Stack>
          <Stack
            gap={isDesktop ? '8px' : '4px'}
            width={isDesktop ? '275px' : '135px'}
          >
            <Typography variant={'body6'}>
              {dictionary.treatmentStatusDate}
            </Typography>
            <Typography variant={'body2'}>{getStatusDate()}</Typography>
          </Stack>
          <Stack
            gap={isDesktop ? '8px' : '4px'}
            width={isDesktop ? '275px' : '135px'}
          >
            <Typography variant={'body6'}>{dictionary.providerName}</Typography>
            <Typography variant={'body2'}>
              {supplierName ?? dictionary.decideLater}
            </Typography>
          </Stack>
          {isDesktop && (
            <AppliesNumbers linkedApplyNumbers={linkedApplyNumbers} />
          )}
        </Stack>
      </Stack>
      {!isDesktop && (
        <>
          <Divider
            orientation={'horizontal'}
            aria-hidden={'true'}
            sx={{
              borderColor: 'primary.shade_100',
              m: '16px 0',
            }}
          />
          <AppliesNumbers linkedApplyNumbers={linkedApplyNumbers} />
        </>
      )}
    </Stack>
  );
};
